import { useContext } from 'react';

import { INotificationsContext, NotificationsContext } from './NotificationsContext';

export const useNotifications = (): INotificationsContext => {
	return useContext(NotificationsContext);
};
